import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Orders({ data }) {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="p-4 border border-gray-200 bg-white shadow rounded-lg overflow-auto h-[70vh] ">
        <div className="flex items-start flex-col">
          <div className="flex-1 order-2 sm:order-1">
            <h2 className="text-xl font-bold text-gray-800">{data?.name}</h2>

            <div className="mt-2">
              <div
                className={`text-sm text-gray-600 ${isExpanded ? '' : 'line-clamp-3'} overflow-hidden`}
                dangerouslySetInnerHTML={{ __html: data?.description }}
              />
              {data?.description && (
                <button
                  onClick={toggleDescription}
                  className="text-sm text-[--color--1] hover:underline mt-1 focus:outline-none"
                >
                  {isExpanded ? 'Read Less' : 'Read More'}
                </button>
              )}
            </div>

            <div className="mt-3 space-y-1">
              <p className="font-medium">
                <span className="text-gray-700">Quality Grade:</span> {data?.quality_grade}
              </p>
              <p className="text-gray-700">
                <span className="font-medium">Harvest Date:</span> {new Date(data?.harvest_date).toDateString()}
              </p>
            </div>

            <div className="mt-3">
              <p className="text-gray-500 line-through">
                MRP: ${parseFloat(data?.mrp_price?.$numberDecimal).toFixed(2)}
              </p>
              <p className="text-[--color--1] font-bold text-lg">
                Sale Price: ${parseFloat(data?.sales_price?.$numberDecimal).toFixed(2)}
              </p>
            </div>

            <p className={`mt-2 font-medium ${data?.in_stock ? 'text-green-600' : 'text-red-600'}`}>
              {data?.in_stock ? "In Stock" : "Out of Stock"}
            </p>
          </div>

          <div className="w-full sm:w-32 h-32 mb-4 sm:mb-0  flex-shrink-0 order-1 sm:order-2">
            <img
              className="w-full h-full object-cover rounded-lg border border-gray-200"
              src={data?.primary_image}
              alt={data?.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/150";
              }}
            />
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-200">
          <h4 className="text-lg font-semibold text-gray-800">Tax Details</h4>
          <ul className="mt-2 space-y-1 text-sm text-gray-700">
            {data?.taxData?.standardTax?.map((tax) => (
              <li key={tax?._id} className="flex justify-between">
                <span>{tax?.name}:</span>
                <span>
                  {parseFloat(tax?.taxAmount?.$numberDecimal)?.toFixed(2)} USD (
                  {parseFloat(tax?.rate?.$numberDecimal)?.toFixed(2)}%)
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-3 pt-2 border-t border-gray-200">
            <p className="flex justify-between font-semibold">
              <span>Total Tax:</span>
              <span>
                ${parseFloat(data?.taxData?.standardTotalTaxAmount?.$numberDecimal).toFixed(2)}
              </span>
            </p>
            <p className="flex justify-between font-bold text-lg mt-1">
              <span>Grand Total:</span>
              <span>
                ${parseFloat(data?.taxData?.grandTotal?.$numberDecimal).toFixed(2)}
              </span>
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            className="bg-[--color--1] text-white px-6 py-2 rounded-lg  transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[--color--1] focus:ring-opacity-50"
            onClick={() => {
              navigate(`/store/product-details/${data?._id}`);
            }}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
}

export default Orders;